// app/javascript/pages/leaderboard.ts
// Smart sticky footer that hides when the user's row is visible

export function initLeaderboard(): void {
  handleStickyFooter();
}

function handleStickyFooter(): void {
  const userRow = document.getElementById("current-user-rank-row");
  const stickyBar = document.getElementById("sticky-user-footer");

  // Guard clause: If the user isn't on the leaderboard at all, or bar is missing
  if (!userRow || !stickyBar) return;

  // Configure the Observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // CASE: User row is VISIBLE on screen.
          // ACTION: Hide the sticky bar (Slide it down).
          stickyBar.classList.add("translate-y-full");
          stickyBar.classList.remove("translate-y-0");
        } else {
          // CASE: User row is OFF screen.
          // ACTION: Show the sticky bar (Slide it up).
          stickyBar.classList.remove("translate-y-full");
          stickyBar.classList.add("translate-y-0");
        }
      });
    },
    {
      root: null, // Watch relative to the viewport
      threshold: 0, // Trigger as soon as even 1 pixel of the row is visible
      rootMargin: "-20px", // Optional: Give it a tiny buffer so it doesn't flicker at the exact edge
    },
  );

  // Start watching the row
  observer.observe(userRow);

  // Cleanup on page unload (Turbo navigation)
  document.addEventListener("turbo:before-cache", () => {
    observer.disconnect();
  });
}
